const updateMultiSelectFacetInfo = (payload) => ({
    payload,
    type: 'UPDATE_MULTI_SELECT_FACET_INFO',
});

export default updateMultiSelectFacetInfo;
